import type { A11yOptions } from 'swiper/types';

import type { MediaEntityType } from '@libs/common-types';

export const MAX_VISIBLE_THUMBNAILS = 5;

export const A11Y_OPTIONS: A11yOptions = {
    enabled: true,
    containerRoleDescriptionMessage: 'Product media gallery',
    itemRoleDescriptionMessage: 'Slide',
    slideLabelMessage: '{{index}} / {{slidesLength}}',
    prevSlideMessage: 'Previous media',
    nextSlideMessage: 'Next media',
};

export const getBulletMediaUrl = (bulletMedia: MediaEntityType) => {
    return `${bulletMedia.type === 'image' ? bulletMedia.url : bulletMedia.poster}?fmt=webp&wid=72&hei=72`;
};
